const HIGHLIGHT_REGEX = /<u>/g;

const countReviewHighlights = (text) => (!text ? 0 : (text.match(HIGHLIGHT_REGEX) || []).length);

/**
 * Counts how many total highlights are in the reviews.
 * @param { Array } reviews
 * @returns The total amount of highlighted sections
 */
export const getTotalHighlightsAmount = (reviews = []) =>
    reviews.reduce((acc, review) => acc + countReviewHighlights(review.highlighted_comment), 0);
